<input *ngIf="!borderless" nz-input value="{{ text ? text : '' }}" readonly [class]="class"
  [class.bg-grey-lighter]="!borderless" (click)="onClick($event.target)" [tabindex]="tabindex" />
<div *ngIf="borderless" class="text-truncate" nz-tooltip [nzTooltipTitle]="text">
  {{ text ? text : '' }}
</div>